<template>
  <div :class="$style.test">
    <div :class="$style.counter">{{current}} / {{length}}</div>
    <h2 :class="$style.question" v-html="question" />
    <div :class="$style.answers">
      <template  v-if="type === 'checkbox'">
        <Checkbox
          v-for="(answer, index) in currentAnswers"
          :disabled="proxyDisabled"
          :result="proxyResult"
          :rightAnswer="answer.right"
          v-model="answer.currentAnswer"
          :type="type"
          :key="`${question}${index}`"
        >
          {{answer.text}}
        </Checkbox>
      </template>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/@ui/Checkbox/Checkbox.vue'

export default {
  name: 'Test',
  components: {
    Checkbox,
  },
  props: {
    question: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    answers: {
      type: Array,
      default: () => [],
    },
    result: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    current: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentAnswers: this.answers,
      proxyResult: this.result,
      proxyValue: this.value,
      proxyDisabled: this.disabled,
    }
  },
  watch: {
    answers: {
      deep: true,
      handler(answers) {
        this.currentAnswers = answers
        this.showButton()
      },
    },
    result() {
      this.proxyResult = this.result
    },
    value() {
      this.proxyValue = this.value
    },
    disabled() {
      this.proxyDisabled = this.disabled
    },
  },
  methods: {
    showButton() {
      const { currentAnswers, type } = this
      if (type === 'checkbox') {
        if (currentAnswers.filter(answer => answer.currentAnswer).length > 0) {
          this.$emit('showButton')
        } else {
          this.$emit('hideButton')
        }
        return
      }
      const isCompleted = this.draggingIsCompleted()
      if (isCompleted) this.$emit('showButton')
    },
    checkboxesIsCompleted() {
      const { currentAnswers } = this
      const availableAnswersCount = currentAnswers.filter(answer => answer.right).length
      const answersCount = currentAnswers.filter(answer => answer.currentAnswer).length

      const count = availableAnswersCount - answersCount

      return count <= 0
    },
    draggingIsCompleted() {
      const { currentAnswers } = this
      return currentAnswers.filter(answer => !(answer.currentAnswer === null)).length === currentAnswers.length
    },
    cooficent() {
      const { currentAnswers } = this

      const hasError = currentAnswers.find(answer => (answer.currentAnswer === !answer.right) && !answer.right)

      if (hasError) return 0

      const rightAnswers = currentAnswers.filter(answer => (answer.currentAnswer === answer.right) && answer.right).length
      const rightQuestions = currentAnswers.filter(answer => answer.right).length || 1

      return rightAnswers / rightQuestions
    },
    stepResult() {
      this.$emit('input', this.proxyValue + Math.round(5 * this.cooficent()))
    },
  },
}
</script>
<style lang="scss" module>
@import './Test.sass';
</style>
